export const COMPENSATION_VISIBILITY_KEY = 'compensation_visibility';
export const COMPENSATION_VISIBILITY_VALUES = {
  HIDDEN: 'hidden',
  VISIBLE: 'visible',
};
